import useLogOut from '../../../hooks/useLogOut';
import { closeOktaSession } from '../../../utils/oktaInstance';
import { samlTestConnectionEnd } from '../../AccessManagement/SingleSignOn/utils/saml.calls';

interface FlagSamlTestConnectionEndProps {
  testStatus: string;
}

const useSamlTestingConnection = () => {
  const { performLogout } = useLogOut();

  const flagSamlTestConnectionEnd = async ({ testStatus }: FlagSamlTestConnectionEndProps) => {
    const samlTestStep = window.sessionStorage.getItem('samlTestStep');
    let samlTestId: string | undefined;
    try {
      const parsed = JSON.parse(samlTestStep ?? JSON.stringify({}));
      const { samlTestId: testId, samlId } = parsed;
      samlTestId = testId;

      samlTestId &&
        (await samlTestConnectionEnd(samlId, {
          testId: samlTestId,
          status: testStatus
        }));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Error on test saml connection end', e);
    } finally {
      await closeOktaSession();
    }
    const notificationValue = samlTestId ? `${testStatus}_activation` : testStatus;
    window.sessionStorage.setItem('samlRedirectAndNotification', notificationValue);
    window.sessionStorage.removeItem('samlTestStep');
    window.sessionStorage.removeItem('samlLogoutUrl');
    await performLogout();
  };

  return { flagSamlTestConnectionEnd };
};

export default useSamlTestingConnection;
